import React from 'react';
import { ProjectStatus, StepStatus } from '../../types';

type AnyStatus = ProjectStatus | StepStatus;

const STATUS_CONFIG: Record<AnyStatus, { label: string; color: string; bg: string; dot: string }> = {
  pending:     { label: 'Pendiente',   color: '#9896ac', bg: 'rgba(152,150,172,0.1)',  dot: '#9896ac' },
  in_progress: { label: 'En proceso',  color: '#f97316', bg: 'rgba(249,115,22,0.12)',  dot: '#f97316' },
  done:        { label: 'Completado',  color: '#22c55e', bg: 'rgba(34,197,94,0.12)',   dot: '#22c55e' },
  cancelled:   { label: 'Cancelado',   color: '#ef4444', bg: 'rgba(239,68,68,0.12)',   dot: '#ef4444' },
  skipped:     { label: 'Saltado',     color: '#6b6880', bg: 'rgba(107,104,128,0.1)',  dot: '#6b6880' },
};

export function StatusBadge({ status }: { status: AnyStatus }) {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.pending;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, color: cfg.color, background: cfg.bg, padding: '3px 8px', fontSize: 11, fontFamily: 'JetBrains Mono, monospace', borderRadius: 4, fontWeight: 600, letterSpacing: '0.02em' }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: cfg.dot, display: 'inline-block', ...(status === 'in_progress' ? { boxShadow: `0 0 6px ${cfg.dot}` } : {}) }} />
      {cfg.label.toUpperCase()}
    </span>
  );
}
